// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1q9HO","signatureBlock":"Footer_signatureBlock__3Oqeo","signature":"Footer_signature__4f0tC"};